var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M15.1111111,0 L0.888888889,0 C0.397969111,0 0,0.397969111 0,0.888888889 L0,15.1111111 C0,15.6020309 0.397969111,16 0.888888889,16 L8.54666667,16 L8.54666667,9.81333333 L6.46888889,9.81333333 L6.46888889,7.39111111 L8.54666667,7.39111111 L8.54666667,5.61333333 C8.54666667,3.54666667 9.80888889,2.42222222 11.6577778,2.42222222 C12.2797891,2.42040443 12.9014417,2.45230307 13.52,2.51777778 L13.52,4.66666667 L12.24,4.66666667 C11.24,4.66666667 11.0466667,5.14222222 11.0466667,5.84222222 L11.0466667,7.38444444 L13.4444444,7.38444444 L13.1333333,9.80666667 L11.0466667,9.80666667 L11.0466667,16 L15.1111111,16 C15.6020309,16 16,15.6020309 16,15.1111111 L16,0.888888889 C16,0.397969111 15.6020309,0 15.1111111,0 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c046a708.svg";
export { ForwardRef as ReactComponent };